import React from 'react';
import { motion } from 'framer-motion';
import { Search, Map, TrendingUp, ArrowRight } from 'lucide-react';
const steps = [{
  icon: Search,
  title: '1. Analyze Operations',
  desc: 'Review current dispatch, back-office, and cash flow.'
}, {
  icon: Map,
  title: '2. Identify Bottlenecks',
  desc: "Pinpoint exactly what's trapping the owner in day-to-day."
}, {
  icon: TrendingUp,
  title: '3. Map Growth Roadmap',
  desc: 'Build a practical plan for scalable systems and rhythm.'
}];
export function ConsultationSteps() {
  return <section className="bg-navy border-t border-white/10 py-8 relative z-20 shadow-xl" data-id="element-15">
      <div className="container-custom" data-id="element-16">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8" data-id="element-17">
          <div className="lg:w-1/4 text-center lg:text-left" data-id="element-18">
            <h3 className="text-white font-heading font-bold text-lg md:text-xl leading-tight" data-id="element-19">
              What happens on the free consultation?
            </h3>
          </div>

          <div className="lg:w-2/4 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-4 w-full" data-id="element-20">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex flex-col items-center text-center md:items-start md:text-left" data-id="element-21">
                <div className="flex items-center mb-2" data-id="element-22">
                  <step.icon className="w-5 h-5 text-amber mr-2" data-id="element-23" />
                  <h4 className="text-white font-bold text-sm uppercase tracking-wider" data-id="element-24">
                    {step.title}
                  </h4>
                </div>
                <p className="text-white/60 text-xs leading-relaxed" data-id="element-25">
                  {step.desc}
                </p>
              </motion.div>)}
          </div>

          <div className="lg:w-1/4 flex justify-center lg:justify-end w-full" data-id="element-26">
            <a href="#contact" className="btn-primary w-full sm:w-auto group text-xs py-3" data-id="element-27">
              Book a Free 1:1 Consultation
              <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-28" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}